<button #button (click)="clicked ($event)" 
[disabled]="disabled"
[ngClass]="buttonClass"
></button>